<template>
  <div class="advantage-item">
    <img class="item-icon" :src="icon" />
    <div class="item-label" v-html="label" />
  </div>
</template>

<script>
  export default {
    name: 'advantage-item',

    props: ['icon', 'label']
  }
</script>

<style lang="scss" scoped>
  .advantage-item {
    width: 100%;
    height: 64px;
    border-radius: 8px;
    background-image: url('../../../assets/images/invite_row_bg.webp');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 8px;

    .item-icon {
      width: 32px;
      height: 32px;
      margin: 0 10px;
    }

    .item-label {
      flex: 1;
      padding-right: 28px;
      font-size: 13px;
      font-weight: 500;
      line-height: 18px;
      color: #08346a;
    }
  }
</style>
